import { Controller } from '@hotwired/stimulus'
import { isTurboFrameVisit } from '../../utilities/is_turbo_frame_visit'

// Connects to data-controller="forms--unsaved"
export default class extends Controller {
  static values = {
    // Useful for when the user just submitted an invalid form, in which case we
    // consider the form to be dirty even on initial load.
    dirty: {type: Boolean, default: false},
    confirmMsg: {type: String, default: "Leave with unsaved changes?"}
  }

  setDirty() { this.dirtyValue = true }
  setNotDirty() { this.dirtyValue = false }

  confirm(e) {
    if (
      this.dirtyValue &&
      !window.confirm(this.confirmMsgValue)
    ) {
      e.preventDefault()
    }
  }

  onBeforeFetch(e) {
    if (isTurboFrameVisit(e)) {
      this.confirm(e)
    }
  }

  onBeforeUnload(e) {
    if (this.dirtyValue) {
      e.preventDefault() // triggers prompt, no way to modify message
      return (e.returnValue = true) // legacy
    }
  }
}
